import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import api from "../../services/api"
import { openLinkExternal } from "../../utils/utils"
import Loading from "../layouts/Loading"
import Button from "../../components/Form/Button"
import Input from "../../components/Form/Input"
import Textarea from "../../components/Form/Textarea"

const InstagramOAuthCallback = () => {
    const [params, setParams] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState("")
    const [accountId, setAccountId] = useState("")
    const [debugData, setDebugData] = useState(null)
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const code = searchParams.get("code")
        const stateString = searchParams.get("state")
        let state = {}

        try {
            state = stateString ? JSON.parse(decodeURIComponent(stateString)) : {}
        } catch (err) {
            console.error("Erro ao parsear o estado do Instagram:", err)
        }

        if (code && state?.account_id) {
            console.info("Instagram OAuth callback recebido.", { hasCode: true, account_id: state.account_id })
            setAccountId(state.account_id)
            setParams({ code, account_id: state.account_id })
        } else {
            console.error("Instagram OAuth callback inválido.", { hasCode: !!code, stateString, state })
            const message = "Não foi possível concluir o login do Instagram. Abra a integração e tente conectar novamente."
            setError(message)
            setIsLoading(false)
            toast.error(message)
        }
    }, [searchParams])

    useEffect(() => {
        if (params.code && params.account_id) {
            handleSaveCode(params.code, params.account_id)
        }
    }, [params])

    const handleSaveCode = async (code, account_id) => {
        try {
            const redirectUri = `${window.location.origin}/instagram/oauth/callback`
            if (process.env.REACT_APP_INSTAGRAM_OAUTH_DEBUG_ONLY === "true") {
                const stateString = searchParams.get("state")
                const data = { code, account_id, redirect_uri: redirectUri, state: stateString }
                setDebugData(data)
                setIsLoading(false)
                console.info("Instagram OAuth debug code. A Oktto nao trocou este codigo por token.", data)
                await api.post("/integrations/instagram/oauth-debug-code", data).catch(err => {
                    console.error("Erro ao registrar code de debug do Instagram.", err?.response?.data || err)
                })
                toast.info("Modo diagnóstico: código do Instagram gerado sem troca por token.")
                return
            }

            await api.patch("/integrations/instagram/accessToken", { code, account_id, redirect_uri: redirectUri })
            toast.success("Login do Instagram concluído com sucesso.")
            openLinkExternal(`/${account_id}/integrations/chat/instagram-direct?instagram_login=success`, false, "_self")
        } catch (err) {
            console.error("Erro ao salvar token do Instagram.", err?.response?.data || err)
            const message = err?.response?.data?.message || "Não foi possível concluir o login do Instagram."
            setError(message)
            toast.error(message)
            setIsLoading(false)
        }
    }

    if (debugData) {
        return (
            <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#f7f8fa" }}>
                <div style={{ width: "100%", maxWidth: 760, background: "#fff", border: "1px solid #e6e8ec", borderRadius: 8, padding: 24, boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)" }}>
                    <h1 style={{ margin: "0 0 8px", fontSize: 22, color: "#1f2937" }}>Código do Instagram gerado</h1>
                    <p style={{ margin: "0 0 16px", color: "#4b5563", lineHeight: 1.5 }}>
                        Modo diagnóstico ativo. A Oktto não trocou este código por token, então ele pode ser usado uma vez no Postman.
                    </p>
                    <label style={{ display: "block", marginBottom: 8, color: "#374151", fontWeight: 600 }}>Code</label>
                    <Textarea readOnly value={debugData.code} style={{ width: "100%", minHeight: 96, resize: "vertical", marginBottom: 16 }} />
                    <label style={{ display: "block", marginBottom: 8, color: "#374151", fontWeight: 600 }}>Redirect URI</label>
                    <Input readOnly value={debugData.redirect_uri} style={{ width: "100%", marginBottom: 20 }} />
                    <Button
                        type="button"
                        fullWidth={false}
                        onClick={() => openLinkExternal(accountId ? `/${accountId}/integrations/chat/instagram-direct` : "/", false, "_self")}
                    >
                        Voltar para a integração
                    </Button>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#f7f8fa" }}>
                <div style={{ width: "100%", maxWidth: 520, background: "#fff", border: "1px solid #e6e8ec", borderRadius: 8, padding: 24, boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)" }}>
                    <h1 style={{ margin: "0 0 8px", fontSize: 22, color: "#1f2937" }}>Login do Instagram não concluído</h1>
                    <p style={{ margin: "0 0 20px", color: "#4b5563", lineHeight: 1.5 }}>{error}</p>
                    <Button
                        type="button"
                        fullWidth={false}
                        onClick={() => openLinkExternal(accountId ? `/${accountId}/integrations/chat/instagram-direct` : "/", false, "_self")}
                    >
                        Voltar para a integração
                    </Button>
                </div>
            </div>
        )
    }

    if (!isLoading) return null

    return <Loading />
}

export default InstagramOAuthCallback
